const TOKEN_KEY = "token";
const USER_KEY = "user";
const CITY_KEY = "city";
const CITY_FUQIN_KEY = "cityFuqin";
const CITY_SON_KEY = "citySon";
const ADDRESS_FULL_KEY = "addressFull";
const BIGSCREEN_ADDRESS_CODE_KEY = "bigscreenaddresscode";

function parseStorageJson(key) {
  const rawValue = localStorage.getItem(key);
  if (!rawValue || rawValue === "null" || rawValue === "undefined") {
    return null;
  }
  try {
    return JSON.parse(rawValue);
  } catch (error) {
    return null;
  }
}

export function saveAuth(data) {
  const authData = data || {};
  localStorage.setItem(TOKEN_KEY, authData.token || "");
  localStorage.setItem(BIGSCREEN_ADDRESS_CODE_KEY, authData.bigscreenaddresscode || "");
  localStorage.setItem(USER_KEY, JSON.stringify(authData));
  localStorage.setItem(CITY_KEY, JSON.stringify(authData.city || ""));
  localStorage.setItem(CITY_FUQIN_KEY, JSON.stringify(authData.cityFuqin || {}));
  localStorage.setItem(CITY_SON_KEY, JSON.stringify(authData.citySon || []));
  localStorage.setItem(ADDRESS_FULL_KEY, JSON.stringify(authData.addressFull || ""));
}

export function clearAuth() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  localStorage.removeItem(CITY_KEY);
  localStorage.removeItem(CITY_FUQIN_KEY);
  localStorage.removeItem(CITY_SON_KEY);
  localStorage.removeItem(ADDRESS_FULL_KEY);
  localStorage.removeItem(BIGSCREEN_ADDRESS_CODE_KEY);
}

export function getToken() {
  const token = localStorage.getItem(TOKEN_KEY);
  if (!token || token === "null" || token === "undefined") {
    return "";
  }
  return token;
}

export function getBigscreenAddressCode() {
  const code = localStorage.getItem(BIGSCREEN_ADDRESS_CODE_KEY);
  if (!code || code === "null" || code === "undefined") {
    return "";
  }
  return code;
}

export function getUser() {
  return parseStorageJson(USER_KEY) || {};
}

export function getCityFuqin() {
  return parseStorageJson(CITY_FUQIN_KEY) || {};
}

export function getCitySon() {
  return parseStorageJson(CITY_SON_KEY) || [];
}

export function isLoggedIn() {
  return getToken() !== "";
}
